import { useState } from 'react';
import AuthSlider from './AuthSlider';
import LoginForm from './LoginForm';

const StudentLoginPage = ({ setIsLoggedIn }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gray-50">
      {/* Slider Section - Left Side */}
      <AuthSlider currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
      
      {/* Login Form Section - Right Side */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 h-screen overflow-auto">
        <div className="w-full max-w-md">
          <LoginForm setIsLoggedIn={setIsLoggedIn} />
        </div>
      </div>
    </div>
  );
};

export default StudentLoginPage;